import { CenteredContentBlocks } from "@components/article/CenteredContentBlocks"
import { StaggerTransitionRoot, Transition } from "@components/motion/Transition"
import { useRoutePriority } from "@hooks/useRouteIndex"
import { ContentBlock, ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"
import { useMemo } from "react"

export default defineView("single-hall-of-fame", (props) => {
  const blocks = useMemo(() => {
    return props.hallOfFameArticle?.contentBlocks.flatMap((block) => {
      if (block.blockName === "acf/article-article-siderail") {
        return block.innerBlocks
      } else {
        return block
      }
    }) as ContentBlock[]
  }, [props.hallOfFameArticle?.contentBlocks])

  return (
    <StaggerTransitionRoot>
      <CenteredContentBlocks blocks={blocks} />
    </StaggerTransitionRoot>
  )
})
